import { JSONCompatible } from '@direct-frontend/stdlib';
import { RequestError } from '../RequestError';

// Проверяет, что ошибка является инстансом RequestError
export function isRequestError(err: unknown): err is RequestError<JSONCompatible<unknown>> {
    return err instanceof RequestError;
}
